import { render, staticRenderFns } from "./UniLoadingView.vue?vue&type=template&id=04f552c0"
import script from "./UniLoadingView.vue?vue&type=script&lang=js"
export * from "./UniLoadingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports